import { TransferGroup } from './transfer-group';
import { TransferItem } from './transfer-item';

export class TransferData {
	userId: number;
	// eslint-disable-next-line id-blacklist
	transferItems: {number: {[key in TransferGroup]: TransferItem[]}};
	transferWidgetsInUnownedDashboards: boolean;
	retainEditPermission: boolean;
}